// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import windowConfig from "./window";
import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "@/store/index.js";
import axios from "axios";
import moment from "moment";

import ViewUI from "view-design";
import "view-design/dist/styles/iview.css";
import "@/assets/style/index.less";
import { $get, $post } from "@/data/http.js";

import permission from "@/data/permission.js";

import VueTreeSelect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
Vue.component("vue-tree-select", VueTreeSelect);

Vue.prototype.windowConfig = windowConfig;

Vue.prototype.axios = axios;
Vue.prototype.$get = $get;
Vue.prototype.$post = $post;
Vue.prototype.baseFontSize = window.innerWidth >= 5000 ? 48
    : window.innerWidth >= 4000 ? 40
        : window.innerWidth >= 3200 ? 30
            : window.innerWidth >= 2400 ? 24 : 16;
Vue.prototype.moment = moment;

Vue.use(ViewUI).use(permission);

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
    el: "#app",
    store,
    router,
    components: { App },
    template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js